var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-password"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_c('div',{staticClass:"control"},[_c('input',{attrs:{"type":[_vm.showPassword ? 'text' : 'password']},domProps:{"value":_vm.value},on:{"input":_vm.input}}),_c('button',{staticClass:"button",on:{"click":_vm.toggleShow}},[_c('span',{staticClass:"icon is-small is-right"},[_c('i',{staticClass:"fas",class:{
            'feather-eye-off': _vm.showPassword,
            'feather-eye': !_vm.showPassword,
          }})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }